/* Native Shopify preferences; never invent or migrate consent decisions. */
(function () {
  'use strict';
  var button = document.getElementById('sdv-cookie-settings');
  if (!button) return;
  function updateControls() {
    button.disabled = !(window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function');
    var link = document.getElementById('shopify-pc__banner__body-policy-link');
    if (link && link.getAttribute('href') !== '/policies/privacy-policy') {
      link.setAttribute('href', '/policies/privacy-policy');
    }
  }
  button.addEventListener('click', function () {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    }
  });
  updateControls();
  new MutationObserver(updateControls).observe(document.documentElement, {childList:true, subtree:true});
})();
